module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"edit_comment_label":"修改評論","delete_comment_label":"刪除評論","delete_comment_confirmation":"確定要刪除評論嗎？"}}')
  delete Component.options._Ctor
}
